<brf-news-loader></brf-news-loader>
<brf-news-header></brf-news-header>
<router-outlet (activate)="onActivate($event)"></router-outlet>
<brf-news-footer></brf-news-footer>
